// extracted by mini-css-extract-plugin
export default {"wrapper":"CoverImage_wrapper__q-iOh","placeholder":"CoverImage_placeholder__foWfn","img":"CoverImage_img__896dI"};